<template>
	<ProductProductAttributes />
</template>
